/* Sprayo CRO — keep an accordion header still while the panels animate.

   Opening one panel closes another. When the one that closes sits ABOVE the
   one you clicked, everything below it moves up — so the header jumps out
   from under your finger mid-tap. Measured at 72px on a phone.

   The theme does not scroll; this is pure layout shift. The fix is to hold
   the clicked header at the same point in the viewport while the heights
   settle, correcting every frame because the transition is gradual rather
   than instant. */

(() => {
  const TRIGGER = ".sprayo-collapse .wt-collapse__trigger";
  const SETTLE_MS = 650; // a little past the 380ms transition

  document.addEventListener(
    "click",
    (event) => {
      const trigger = event.target.closest(TRIGGER);
      if (!trigger) return;

      const start = trigger.getBoundingClientRect().top;
      const deadline = performance.now() + SETTLE_MS;
      let cancelled = false;

      // The theme sets `html { scroll-behavior: smooth }`, which turns each
      // correction into an animation — so instead of holding still the page
      // swooped away and eased back. Suspend it while we pin, and put it back
      // exactly as we found it.
      const root = document.documentElement;
      const previousBehavior = root.style.scrollBehavior;
      root.style.scrollBehavior = "auto";
      const restore = () => {
        root.style.scrollBehavior = previousBehavior;
      };

      // If the reader starts scrolling themselves, stop fighting them.
      const release = () => {
        cancelled = true;
        restore();
      };
      window.addEventListener("wheel", release, { once: true, passive: true });
      window.addEventListener("touchstart", release, { once: true, passive: true });

      const pin = () => {
        if (cancelled) return;
        const drift = trigger.getBoundingClientRect().top - start;
        if (Math.abs(drift) > 0.5) {
          // `instant` as well as the style override — belt and braces, since
          // one wins in CSS and the other in the scroll options.
          window.scrollTo({ top: window.scrollY + drift, behavior: "instant" });
        }
        if (performance.now() < deadline) {
          requestAnimationFrame(pin);
        } else {
          restore();
          window.removeEventListener("wheel", release);
          window.removeEventListener("touchstart", release);
        }
      };

      // Correct once as soon as the theme's own handler has toggled, before
      // the browser paints. Waiting for the first animation frame let a single
      // displaced frame reach the screen, which reads as a flick even though
      // the net movement is zero.
      document.addEventListener("click", pin, { once: true });
      requestAnimationFrame(pin);
    },
    // Capture, so the position is measured before the panel toggles.
    true
  );
})();
